import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOrders } from "./../../constants";
import {
  AssignDriverRequest,
  AssignDriverResponse
} from "./assignDriver.types";

export const requestAssignDriver = async ({
  orderId,
  driverId
}: AssignDriverRequest): Promise<AssignDriverResponse> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesOrders.Orders,
      orderId,
      ApiRoutesOrders.AssignDriver,
      driverId
    )
  );
};
